import { render, staticRenderFns } from "./SubjectPreview.vue?vue&type=template&id=3b7d571c&scoped=true"
import script from "./SubjectPreview.vue?vue&type=script&lang=js"
export * from "./SubjectPreview.vue?vue&type=script&lang=js"
import style0 from "./SubjectPreview.vue?vue&type=style&index=0&id=3b7d571c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d571c",
  null
  
)

export default component.exports